import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsHazardousStyles {
    wrapper?: InjectableCss;
    hazardousIconContent?: InjectableCss;
    hazardousTooltip?: InjectableCss;
}

export const hazardousStyles: ProductDetailsHazardousStyles = {
    wrapper: {
        css: css`
            margin-bottom: 0 !important;
        `,
    },
    hazardousIconContent: {
        css: css`
            background: url(/UserFiles/Images/Icons/hazardousicon.png) no-repeat 0 0;
            padding: 11px 0px 7px 36px;
            color: #193066;
            font-size: 13px;
            font-weight: bold;
            margin-top: 15px;
            position: relative;
            &:hover {
                > div {
                    visibility: visible;
                }
            }
        `,
    },
    hazardousTooltip: {
        css: css`
            visibility: hidden;
            font-size: 12px;
            background: #353432;
            color: #fff;
            font-weight: normal;
            border-radius: 6px;
            position: absolute;
            z-index: 1;
            top: 110%;
            left: 0;
            padding: 5px 7px;
            &:before {
                content: "";
                display: block;
                width: 0;
                height: 0;
                position: absolute;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid #353432;
                left: 30%;
                top: -8px;
                z-index: 99;
            }
        `,
    },
};

const styles = hazardousStyles;

const ProductDetailsHazardous: React.FC<Props> = ({ product }) => {
    if (!product.detail) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {product.detail.isHazardousGood && (
                <StyledWrapper {...styles.hazardousIconContent}>
                    {translate("Hazardous Materials")}
                    <StyledWrapper {...styles.hazardousTooltip}>
                        {translate("This item is marked hazardous when shipping with UPS or FedEx.")}
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsHazardous),
    definition: {
        displayName: "Hazardous",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
